import * as React from 'react';
import { IgcColumnLayoutComponent as Component } from 'igniteui-webcomponents-grids/grids/index.js';
import type { IgcColumnLayoutComponentEventMap } from 'igniteui-webcomponents-grids/grids/index.js';
import { type EventName, createComponent } from '../react-props.js';

/**
 * Column layout for declaration of Multi-row Layout
 * @fires hiddenChange - Emitted when the column is hidden or shown.
 * @fires expandedChange - Emitted when the column expanded or collapsed.
 * @fires widthChange - Emitted when the column width changes.
 * @fires pinnedChange - Emitted when the column is pinned/unpinned.
 * @class
 */
export const IgrColumnLayout = /* @__PURE__ */ createComponent({
  tagName: 'igc-column-layout',
  displayName: 'IgrColumnLayout',
  elementClass: Component,
  react: React,
  moveBackOnDelete: true,
  events: {
    onHiddenChange: 'hiddenChange' as EventName<
      IgcColumnLayoutComponentEventMap['hiddenChange']
    >,
    onExpandedChange: 'expandedChange' as EventName<
      IgcColumnLayoutComponentEventMap['expandedChange']
    >,
    onWidthChange: 'widthChange' as EventName<
      IgcColumnLayoutComponentEventMap['widthChange']
    >,
    onPinnedChange: 'pinnedChange' as EventName<
      IgcColumnLayoutComponentEventMap['pinnedChange']
    >,
  },
  renderProps: {
    collapsibleIndicatorTemplate: 'collapsibleIndicatorTemplate',
    summaryTemplate: 'summaryTemplate',
    bodyTemplate: 'bodyTemplate',
    headerTemplate: 'headerTemplate',
    inlineEditorTemplate: 'inlineEditorTemplate',
    errorTemplate: 'errorTemplate',
    filterCellTemplate: 'filterCellTemplate',
  },
});

export type IgrColumnLayout = Component;

/** @deprecated Module register is no longer needed and can be removed */
export const IgrColumnLayoutModule = Component;
